import Crypto from "crypto-js"

let {log, floor} = Math

// key is an ascii string (base 256)
function getCode(key, {time = new Date(), interval = 30}) {
  let timeTag = floor(time.valueOf() / 1000 / interval)
  timeTag = BasedValue(timeTag, 10).toWords(64)
  let encrypted = Crypto.HmacSHA1(timeTag, key).toString()
  let offset = parseInt(encrypted.at(-1),16)*2
  let fullCode = encrypted.split("").splice(offset, 8).join("")
  let code = parseInt(fullCode, 16) & 0x7fffffff
  return code.toString().slice(-8)
}


function BasedValue(value, base = guessBase(value)) {
  let self = {
    value: value.toString(),
    base: parseInt(base),
    toBigInt: toBigInt,
    toString: toString,
    toWords: toWords,
  }

  let base16characters = "0123456789ABCDEF"
  let base32characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"
  let base64Characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
  let _parseInt = (character, base) => {
    if (base <= 16) {
      return base16characters.indexOf(character.toUpperCase())
    } else if (base === 32) {
      return base32characters.indexOf(character.toUpperCase())
    } else if (base === 64) {
      return base64Characters.indexOf(character)
    } else if (base === 256) { // ascii
      return character.charCodeAt(0)
    }
  }

  function toBigInt() {
    return [...self.value].reduce((result, value) => {
      return result * BigInt(self.base) + BigInt(_parseInt(value, self.base))
    }, 0n)
  }

  function toString(newBase = self.base, bits = undefined, debug = false) {
    if (debug) debugger
    let result = ""
    if (newBase < 16 || self.base < 16) {
      let numericValue = self.toBigInt()
      result = numericValue.toString(newBase)
    } else {
      let asciiValue = toAscii(self.value, self.base)
      result = fromAscii(asciiValue, newBase)
    }

    let zero_character = newBase === 256 ? "\0" : "0"
    bits ||= self.value.length * log(self.base) / log(2)
    let newCharacterLength = floor(bits / (log(newBase)/log(2)))
    return result.padStart(newCharacterLength, zero_character)
  }


  function toBase(newBase) {
    if (newBase > 16 || self.base > 16) {
      self.toAscii(self.value, self.base)
    }
  }

  function toAscii(value, fromBase) {
    if (fromBase === 256) return value
    let bytes = []
    let outputLength = Infinity
    if (fromBase === 16) {
      value = value.toUpperCase().padStart(2, "0")
      bytes = value.match(/.{2}/g).map((pair) => {
        return parseInt(pair, 16)
      })
    } else if (fromBase === 32) {
      value = value.replace(/=+$/, "")
      let charCount = value.length
      outputLength = Math.floor(charCount*5/8)
      let padding = Math.ceil(charCount/8) * 8
      value = value.padEnd(padding, "A")
      bytes = value.split("").map((char) => {
        return base32characters.indexOf(char).toString(2).padStart(5, "0")
      }).join("").match(/.{8}/g).map((bitGroup) => {
        return parseInt(bitGroup, 2)
      })
    } else if (fromBase === 64) {
      value = value.replace(/=+$/, "")
      let charCount = value.length
      outputLength = Math.floor(charCount*6/8)
      let padding = Math.ceil(charCount/4) * 4
      value = value.padEnd(padding, "A")
      bytes = value.split("").map((char) => {
        return base64Characters.indexOf(char).toString(2).padStart(6, "0")
      }).join("").match(/.{8}/g).map((bitGroup) => {
        return parseInt(bitGroup, 2)
      })
    }
    return bytes.map((byte) => {
      return String.fromCharCode(byte)
    }).join("").slice(0,outputLength)
  }

  function fromAscii(value, toBase) {
    if (!value) return value
    if (toBase === 256) return value
    let outputLength = Infinity
    let bits = value.split("").map((char) => {
      return char.charCodeAt(0).toString(2).padStart(8, "0")
    }).join("")
    if (toBase === 16) {
      outputLength = Math.ceil(bits.length/4)
      bits = bits + "00"
      return bits.match(/.{4}/g).map((binary) => {
        return base16characters[parseInt(binary, 2)]
      }).slice(0, outputLength).join("")
    } else if (toBase === 32) {
      outputLength = Math.ceil(bits.length/5)
      let paddedLength = Math.ceil(outputLength/8) * 8
      bits = bits + "00000"
      return bits.match(/.{5}/g).map((binary) => {
        return base32characters[parseInt(binary, 2)]
      }).slice(0, outputLength).join("").padEnd(paddedLength, "=")
    } else if (toBase === 64) {
      outputLength = Math.ceil(bits.length/6)
      let paddedLength = Math.ceil(outputLength/4) * 4
      bits = bits + "000000"
      return bits.match(/.{6}/g).map((binary) => {
        return base64Characters[parseInt(binary, 2)]
      }).slice(0, outputLength).join("").padEnd(paddedLength, "=")

    }
  }

  window.toAscii = toAscii
  window.fromAscii = fromAscii

  function toWords(bits = undefined) {
    let result = self.toString(16, bits)
    return Crypto.enc.Hex.parse(result)
  }

  return self
}


function guessBase(value) {
  if (value.length < 4) return
  let hasDigits = !!value.match(/\d/)
  let hasLetters = !!value.match(/[a-zA-Z]/)
  let hasLowerCase = !!value.match(/[a-z]/)
  let hasUpperCase = !!value.match(/[A-Z]/)
  let hasBothCases = hasLowerCase && hasUpperCase
  let hasLateLetters = !!value.match(/[g-zG-Z]/)

  if (hasDigits && !hasLowerCase && !hasUpperCase) {
    return 10
  } else if (hasLetters && !hasBothCases && !hasLateLetters) {
    return 16
  } else if (hasLetters && !hasBothCases && hasLateLetters) {
    return 32
  } else if (hasLetters && hasBothCases) {
    return 64
  } else {
    return
  }
}

export { getCode, guessBase, BasedValue }